/* eslint-disable no-useless-constructor,react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './pin-search.scss';
import React, { Component } from 'react';
import BusyCounterLoadingIndicator from '../../../../sharedmodules/components/busyCounter/busy-counter-loading-indicator';
import { FormattedMessage } from 'react-intl';
import PinPlateInputField from './pin-plate-input-fields';
import PinPlateSearch from './pin-plate-search';
import PropTypes from 'prop-types';
import { createPinPlateRequest } from '../../services/pin-plate-helper';

class PinPlateSearchSettings extends Component {

    constructor(props) {

        super(props);
        this.state = {
            isDealer: false,
        };

    }

    componentWillMount() {

        this.props.actions.resetPinPlateData();

    }

    handleExecute = (userDetails, props) => {

        const userDealerRequest = createPinPlateRequest(userDetails);
        this.props.actions.searchPinPlateData(props.auth.getAccessToken, userDealerRequest);
        this.setState({ isDealer: true });

    };

    render() {

        const { busyCounter, userDealerMappedData } = this.props;

        return (
            <section className="dealer-settings">
                <section className="dealer-settings-panel">
                    <BusyCounterLoadingIndicator busyCounter={busyCounter} />
                    <div className="dealer-settings-header">
                        <h5>
                            <FormattedMessage id="DUPLICATE_PIN_PLATE_REPORT" />
                        </h5>
                    </div>
                    <PinPlateInputField
                        handleExecute={
                            (userDetails) => this.handleExecute(userDetails, this.props)}
                        handleReset={() => this.props.actions.resetPinPlateData()}
                    />
                </section>
                {this.state.isDealer && (
                    <PinPlateSearch
                        actions={this.props.actions}
                        auth={this.props.auth}
                        pinPlateData={userDealerMappedData}
                    />
                )}
            </section>
        );

    }

}

PinPlateSearchSettings.displayName = 'PinTransferSettings';
PinPlateSearchSettings.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object.isRequired,
    userDealerMappedData: PropTypes.object,
    getPinTransferData: PropTypes.func,
    resetUserDealerData: PropTypes.func,
    busyCounter: PropTypes.bool.isRequired,
    updateTransferComment: PropTypes.func,
};

export default PinPlateSearchSettings;
